
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_45pXct7KTwc5W8b46uFj4ewRjodcqo0QVuRWlcIEaH7wMeta } from "/builds/coingroup/financial-system/backoffice/pages/index.vue?macro=true";
import { default as indexbD__NexG61zCplwZT6wU0SFZ_rnlxeMEbtSaKT6x6EoMeta } from "/builds/coingroup/financial-system/backoffice/pages/auth/index.vue?macro=true";
import { default as index_45PqZkTIQZ70X1umA3YpLRB8IgyZEjZ_7pKYBiD1T2O4Meta } from "/builds/coingroup/financial-system/backoffice/pages/user/index.vue?macro=true";
import { default as indexFEF0TpBlGuPhEUwmGBUcb7Nj3jKaQ7_O26o2iYhsWYgMeta } from "/builds/coingroup/financial-system/backoffice/pages/order/index.vue?macro=true";
import { default as indexcnm4c0_ip0psgscVDftmeZXqDMde1MzCexmijbjY76QMeta } from "/builds/coingroup/financial-system/backoffice/pages/price/index.vue?macro=true";
import { default as indexmNKZcU7WqmcK7Cj7mo1oAT11i2tU816L_45NngsJHAwm8Meta } from "/builds/coingroup/financial-system/backoffice/pages/export/index.vue?macro=true";
import { default as createlJMgZnTozybr44GvDax7w19wWgg3oVho0p5_8Ae5J5UMeta } from "/builds/coingroup/financial-system/backoffice/pages/price/create.vue?macro=true";
import { default as indexsWkG2by0CdyoxPDlXk5rdAt9Rtg9VQO8xKxe6m4g5UIMeta } from "/builds/coingroup/financial-system/backoffice/pages/price-tag/index.vue?macro=true";
import { default as indexOj4kYntncN0jb0_45WvSVFGGK_ICAr7xhD9I_EsE6uJLEMeta } from "/builds/coingroup/financial-system/backoffice/pages/provision/index.vue?macro=true";
import { default as createmBVun85ZdzDnX11IZ_jowId31EIZ7eCeY3mr3c_45CtSkMeta } from "/builds/coingroup/financial-system/backoffice/pages/price-tag/create.vue?macro=true";
import { default as createtxDyjjo19gbzZDQIv1AR7LlGm_4591RVErNMBzUlrtThIMeta } from "/builds/coingroup/financial-system/backoffice/pages/provision/create.vue?macro=true";
import { default as indexZYDZdUoPvvWR962WonzuxoukR0HlkhphIBZkKBBt8zYMeta } from "/builds/coingroup/financial-system/backoffice/pages/audit-event/index.vue?macro=true";
import { default as updateY26Uou13KpLr7M5DJyuzZOZ2WJaPfyZHo5DOJ6Gxcs4Meta } from "/builds/coingroup/financial-system/backoffice/pages/order/[id]/update.vue?macro=true";
import { default as updatefktAFwutNM2q5XYY536bdXxLWSZo6imu6qO9tkIo2KkMeta } from "/builds/coingroup/financial-system/backoffice/pages/price/[id]/update.vue?macro=true";
import { default as indexyWVMJtk_457RrpvbXSp3t68jSCyOlh3SQHvfvWbqLCmg4Meta } from "/builds/coingroup/financial-system/backoffice/pages/transaction/index.vue?macro=true";
import { default as importYvxSfHWLlimDY34PRztxWH0BTVUUlXdhPKlkDRmWosEMeta } from "/builds/coingroup/financial-system/backoffice/pages/transaction/import.vue?macro=true";
import { default as indexkiD_45o6CDqDsH1gvdecJaiU4k8PAL3NTd0_JM37zjwXIMeta } from "/builds/coingroup/financial-system/backoffice/pages/wallet-owner/index.vue?macro=true";
import { default as indexmx_45Pjhvu3wy79F9Lbt77HKXdrDrtAhfeLqIziGhv7g8Meta } from "/builds/coingroup/financial-system/backoffice/pages/business-area/index.vue?macro=true";
import { default as indexlDGGZJn14WJwsE3wCeHh5h92O2N4Dd4BrCMwsdysWLQMeta } from "/builds/coingroup/financial-system/backoffice/pages/agreement-type/index.vue?macro=true";
import { default as create0jSFmNIh7TVVvUIQbHspuS94ndg_45NH6YyEYf_45Hcgz5AMeta } from "/builds/coingroup/financial-system/backoffice/pages/business-area/create.vue?macro=true";
import { default as createHl07_45g_vWrkndWTlG4q5OmHVLb8RQthDzGwbR2uatYEMeta } from "/builds/coingroup/financial-system/backoffice/pages/agreement-type/create.vue?macro=true";
import { default as update10yrANkVby6ezDJt_45H_owmXsX0hl8CyTJ7mh2xDAV9cMeta } from "/builds/coingroup/financial-system/backoffice/pages/price-tag/[id]/update.vue?macro=true";
import { default as updateGbmL9wr8HdNp7PdJtPPpqb1RJEsmFN8K5vx51vMIcW0Meta } from "/builds/coingroup/financial-system/backoffice/pages/provision/[id]/update.vue?macro=true";
import { default as update_45rolesBb0ncAdTYWepeg6_45sTPsYlnhJC9xxCVuECB8nWs1xBMMeta } from "/builds/coingroup/financial-system/backoffice/pages/user/[id]/update-roles.vue?macro=true";
import { default as updatenF3aUF2uaYz3A0Qe1oVaNEq4FwPJAg9KtyniLbXPEM0Meta } from "/builds/coingroup/financial-system/backoffice/pages/money-wallet/[id]/update.vue?macro=true";
import { default as updateYJj7cYMGLvmvmZnSASL7YLnm67DjCSlVyFaBxGNdy7kMeta } from "/builds/coingroup/financial-system/backoffice/pages/wallet-owner/[id]/update.vue?macro=true";
import { default as updaterGLwcprUYUR7_78blzH_5CFvKKMmksG2CKQgacQH5qIMeta } from "/builds/coingroup/financial-system/backoffice/pages/business-area/[id]/update.vue?macro=true";
import { default as indexvOcg9gssJbYeZEmTxHRdBvwhYiC_45gsY_45ZXWw5GJTm2IMeta } from "/builds/coingroup/financial-system/backoffice/pages/export/money-wallet/index.vue?macro=true";
import { default as update43230gkulSM_45zHo7zn8PNzxGlpGe7A2M9uCM7oQpuKAMeta } from "/builds/coingroup/financial-system/backoffice/pages/agreement-type/[id]/update.vue?macro=true";
import { default as indexzNlXRCbfQUJAy0RWSQ38XOp8BE_4591vpu0AR5t_45R94zUMeta } from "/builds/coingroup/financial-system/backoffice/pages/fixing-price-operation/index.vue?macro=true";
import { default as debit_45ruleN6mWOLpapBOkNuIMQqAOaeIejRsiHEJwxoCxlX4eQAwMeta } from "/builds/coingroup/financial-system/backoffice/pages/wallet-owner/[id]/debit-rule.vue?macro=true";
import { default as createmg9D8fnmfl_bOFj_gglcI_45r3LdJYHtA9oFrk4sefH7AMeta } from "/builds/coingroup/financial-system/backoffice/pages/fixing-price-operation/create.vue?macro=true";
import { default as wallet_45listZYg4GtFXaK1k3hbpF3AnUFe4tsaviZQk4wrq5He_0KcMeta } from "/builds/coingroup/financial-system/backoffice/pages/wallet-owner/[id]/wallet-list.vue?macro=true";
import { default as index9ytr9hMH92P5HvwYJA_cnPePqSCEnceBMB172YCByeEMeta } from "/builds/coingroup/financial-system/backoffice/pages/document-for-selling/[id]/index.vue?macro=true";
import { default as indexR0jGa5gH0MHyu4hw9zbCmj5Ubg4VanfDU4htb1rE2dYMeta } from "/builds/coingroup/financial-system/backoffice/pages/fixing-price-operation/[id]/index.vue?macro=true";
import { default as indexO_45Vv_eyLpF6OeskIgtxRxH_X0Yiy3_VrQeWNZZ99LgQMeta } from "/builds/coingroup/financial-system/backoffice/pages/export/transactions-statistic/index.vue?macro=true";
import { default as indexSI_45aNMwmCSA6_45wczP2R3zEtvlaHOlKoWcJl0S36u8qkMeta } from "/builds/coingroup/financial-system/backoffice/pages/create-document-for-selling-operation/index.vue?macro=true";
import { default as createuV4UUiqefzOvWvIXBhP_45OsrUkCJF7pBKnI5cF7TwFOQMeta } from "/builds/coingroup/financial-system/backoffice/pages/create-document-for-selling-operation/create.vue?macro=true";
import { default as indexHVnKl5NQIjK_45kdXaD3P0UGpezdQpwMWeZQIiZt88OIQMeta } from "/builds/coingroup/financial-system/backoffice/pages/create-document-for-selling-operation/[id]/index.vue?macro=true";
import { default as indexQUyeY6Dpp4P8Nh71THSb8NVULbu9gdRrIshVzm9PGEYMeta } from "/builds/coingroup/financial-system/backoffice/pages/update-document-for-selling-operation/[id]/index.vue?macro=true";
import { default as errorstHpvwebX6pOzYUH06iPkSLq388n5QMctg40nFIdqxOkMeta } from "/builds/coingroup/financial-system/backoffice/pages/update-document-for-selling-operation/[id]/errors.vue?macro=true";
import { default as provision_45prices_45priority_45managementJG8z_YjoNUuebrhxtckp8wUuh6zLBPz4bfLIpRko8b8Meta } from "/builds/coingroup/financial-system/backoffice/pages/provision/[id]/provision-prices-priority-management.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index_45pXct7KTwc5W8b46uFj4ewRjodcqo0QVuRWlcIEaH7wMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/index.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexbD__NexG61zCplwZT6wU0SFZ_rnlxeMEbtSaKT6x6EoMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/auth/index.vue")
  },
  {
    name: "user",
    path: "/user",
    meta: index_45PqZkTIQZ70X1umA3YpLRB8IgyZEjZ_7pKYBiD1T2O4Meta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/user/index.vue")
  },
  {
    name: "order",
    path: "/order",
    meta: indexFEF0TpBlGuPhEUwmGBUcb7Nj3jKaQ7_O26o2iYhsWYgMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/order/index.vue")
  },
  {
    name: "price",
    path: "/price",
    meta: indexcnm4c0_ip0psgscVDftmeZXqDMde1MzCexmijbjY76QMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/price/index.vue")
  },
  {
    name: "export",
    path: "/export",
    meta: indexmNKZcU7WqmcK7Cj7mo1oAT11i2tU816L_45NngsJHAwm8Meta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/export/index.vue")
  },
  {
    name: "price-create",
    path: "/price/create",
    meta: createlJMgZnTozybr44GvDax7w19wWgg3oVho0p5_8Ae5J5UMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/price/create.vue")
  },
  {
    name: "price-tag",
    path: "/price-tag",
    meta: indexsWkG2by0CdyoxPDlXk5rdAt9Rtg9VQO8xKxe6m4g5UIMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/price-tag/index.vue")
  },
  {
    name: "provision",
    path: "/provision",
    meta: indexOj4kYntncN0jb0_45WvSVFGGK_ICAr7xhD9I_EsE6uJLEMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/provision/index.vue")
  },
  {
    name: "price-tag-create",
    path: "/price-tag/create",
    meta: createmBVun85ZdzDnX11IZ_jowId31EIZ7eCeY3mr3c_45CtSkMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/price-tag/create.vue")
  },
  {
    name: "provision-create",
    path: "/provision/create",
    meta: createtxDyjjo19gbzZDQIv1AR7LlGm_4591RVErNMBzUlrtThIMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/provision/create.vue")
  },
  {
    name: "audit-event",
    path: "/audit-event",
    meta: indexZYDZdUoPvvWR962WonzuxoukR0HlkhphIBZkKBBt8zYMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/audit-event/index.vue")
  },
  {
    name: "order-id-update",
    path: "/order/:id()/update",
    meta: updateY26Uou13KpLr7M5DJyuzZOZ2WJaPfyZHo5DOJ6Gxcs4Meta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/order/[id]/update.vue")
  },
  {
    name: "price-id-update",
    path: "/price/:id()/update",
    meta: updatefktAFwutNM2q5XYY536bdXxLWSZo6imu6qO9tkIo2KkMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/price/[id]/update.vue")
  },
  {
    name: "transaction",
    path: "/transaction",
    meta: indexyWVMJtk_457RrpvbXSp3t68jSCyOlh3SQHvfvWbqLCmg4Meta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/transaction/index.vue")
  },
  {
    name: "transaction-import",
    path: "/transaction/import",
    meta: importYvxSfHWLlimDY34PRztxWH0BTVUUlXdhPKlkDRmWosEMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/transaction/import.vue")
  },
  {
    name: "wallet-owner",
    path: "/wallet-owner",
    meta: indexkiD_45o6CDqDsH1gvdecJaiU4k8PAL3NTd0_JM37zjwXIMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/wallet-owner/index.vue")
  },
  {
    name: "business-area",
    path: "/business-area",
    meta: indexmx_45Pjhvu3wy79F9Lbt77HKXdrDrtAhfeLqIziGhv7g8Meta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/business-area/index.vue")
  },
  {
    name: "agreement-type",
    path: "/agreement-type",
    meta: indexlDGGZJn14WJwsE3wCeHh5h92O2N4Dd4BrCMwsdysWLQMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/agreement-type/index.vue")
  },
  {
    name: "business-area-create",
    path: "/business-area/create",
    meta: create0jSFmNIh7TVVvUIQbHspuS94ndg_45NH6YyEYf_45Hcgz5AMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/business-area/create.vue")
  },
  {
    name: "agreement-type-create",
    path: "/agreement-type/create",
    meta: createHl07_45g_vWrkndWTlG4q5OmHVLb8RQthDzGwbR2uatYEMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/agreement-type/create.vue")
  },
  {
    name: "price-tag-id-update",
    path: "/price-tag/:id()/update",
    meta: update10yrANkVby6ezDJt_45H_owmXsX0hl8CyTJ7mh2xDAV9cMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/price-tag/[id]/update.vue")
  },
  {
    name: "provision-id-update",
    path: "/provision/:id()/update",
    meta: updateGbmL9wr8HdNp7PdJtPPpqb1RJEsmFN8K5vx51vMIcW0Meta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/provision/[id]/update.vue")
  },
  {
    name: "user-id-update-roles",
    path: "/user/:id()/update-roles",
    meta: update_45rolesBb0ncAdTYWepeg6_45sTPsYlnhJC9xxCVuECB8nWs1xBMMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/user/[id]/update-roles.vue")
  },
  {
    name: "money-wallet-id-update",
    path: "/money-wallet/:id()/update",
    meta: updatenF3aUF2uaYz3A0Qe1oVaNEq4FwPJAg9KtyniLbXPEM0Meta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/money-wallet/[id]/update.vue")
  },
  {
    name: "wallet-owner-id-update",
    path: "/wallet-owner/:id()/update",
    meta: updateYJj7cYMGLvmvmZnSASL7YLnm67DjCSlVyFaBxGNdy7kMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/wallet-owner/[id]/update.vue")
  },
  {
    name: "business-area-id-update",
    path: "/business-area/:id()/update",
    meta: updaterGLwcprUYUR7_78blzH_5CFvKKMmksG2CKQgacQH5qIMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/business-area/[id]/update.vue")
  },
  {
    name: "export-money-wallet",
    path: "/export/money-wallet",
    meta: indexvOcg9gssJbYeZEmTxHRdBvwhYiC_45gsY_45ZXWw5GJTm2IMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/export/money-wallet/index.vue")
  },
  {
    name: "agreement-type-id-update",
    path: "/agreement-type/:id()/update",
    meta: update43230gkulSM_45zHo7zn8PNzxGlpGe7A2M9uCM7oQpuKAMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/agreement-type/[id]/update.vue")
  },
  {
    name: "fixing-price-operation",
    path: "/fixing-price-operation",
    meta: indexzNlXRCbfQUJAy0RWSQ38XOp8BE_4591vpu0AR5t_45R94zUMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/fixing-price-operation/index.vue")
  },
  {
    name: "wallet-owner-id-debit-rule",
    path: "/wallet-owner/:id()/debit-rule",
    meta: debit_45ruleN6mWOLpapBOkNuIMQqAOaeIejRsiHEJwxoCxlX4eQAwMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/wallet-owner/[id]/debit-rule.vue")
  },
  {
    name: "fixing-price-operation-create",
    path: "/fixing-price-operation/create",
    meta: createmg9D8fnmfl_bOFj_gglcI_45r3LdJYHtA9oFrk4sefH7AMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/fixing-price-operation/create.vue")
  },
  {
    name: "wallet-owner-id-wallet-list",
    path: "/wallet-owner/:id()/wallet-list",
    meta: wallet_45listZYg4GtFXaK1k3hbpF3AnUFe4tsaviZQk4wrq5He_0KcMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/wallet-owner/[id]/wallet-list.vue")
  },
  {
    name: "document-for-selling-id",
    path: "/document-for-selling/:id()",
    meta: index9ytr9hMH92P5HvwYJA_cnPePqSCEnceBMB172YCByeEMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/document-for-selling/[id]/index.vue")
  },
  {
    name: "fixing-price-operation-id",
    path: "/fixing-price-operation/:id()",
    meta: indexR0jGa5gH0MHyu4hw9zbCmj5Ubg4VanfDU4htb1rE2dYMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/fixing-price-operation/[id]/index.vue")
  },
  {
    name: "export-transactions-statistic",
    path: "/export/transactions-statistic",
    meta: indexO_45Vv_eyLpF6OeskIgtxRxH_X0Yiy3_VrQeWNZZ99LgQMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/export/transactions-statistic/index.vue")
  },
  {
    name: "create-document-for-selling-operation",
    path: "/create-document-for-selling-operation",
    meta: indexSI_45aNMwmCSA6_45wczP2R3zEtvlaHOlKoWcJl0S36u8qkMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/create-document-for-selling-operation/index.vue")
  },
  {
    name: "create-document-for-selling-operation-create",
    path: "/create-document-for-selling-operation/create",
    meta: createuV4UUiqefzOvWvIXBhP_45OsrUkCJF7pBKnI5cF7TwFOQMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/create-document-for-selling-operation/create.vue")
  },
  {
    name: "create-document-for-selling-operation-id",
    path: "/create-document-for-selling-operation/:id()",
    meta: indexHVnKl5NQIjK_45kdXaD3P0UGpezdQpwMWeZQIiZt88OIQMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/create-document-for-selling-operation/[id]/index.vue")
  },
  {
    name: "update-document-for-selling-operation-id",
    path: "/update-document-for-selling-operation/:id()",
    meta: indexQUyeY6Dpp4P8Nh71THSb8NVULbu9gdRrIshVzm9PGEYMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/update-document-for-selling-operation/[id]/index.vue")
  },
  {
    name: "update-document-for-selling-operation-id-errors",
    path: "/update-document-for-selling-operation/:id()/errors",
    meta: errorstHpvwebX6pOzYUH06iPkSLq388n5QMctg40nFIdqxOkMeta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/update-document-for-selling-operation/[id]/errors.vue")
  },
  {
    name: "provision-id-provision-prices-priority-management",
    path: "/provision/:id()/provision-prices-priority-management",
    meta: provision_45prices_45priority_45managementJG8z_YjoNUuebrhxtckp8wUuh6zLBPz4bfLIpRko8b8Meta || {},
    component: () => import("/builds/coingroup/financial-system/backoffice/pages/provision/[id]/provision-prices-priority-management.vue")
  }
]